import React from 'react';

const AboutPage = () => {

    return (
        <div>
            <h1>PowerGym</h1>
            <p>Web based ERP solution for training centers.</p>
            <p><a href="https://www.sistemapowergym.com">Visit Site</a></p>
        </div>
    );
};


export default AboutPage;
